$(document).ready(function(){
    $( ".js-marquee" ).each( function(){
        $(this).marquee( {
            startVisible: true,
            speed: 22,
            delayBeforeStart: 0,
            duplicated: true,
            pauseOnHover: true
        } );
    } );
});
